import {
	IRPCMethods,
} from './methods'

import {
	ISerializedError
} from '../request'

/**
 * Identifier used to register and deregister listeners
 */
export type ListeningTicket = string;

export type RPCID = string;

/**
 * RPC Request 
 */
 export interface IRPCRequest {
  id: RPCID
  method: keyof IRPCMethods
  parameter: { [key: string]: any }
}

/**
 * RPC Responses 
 */
export interface IRPCResultSuccess { 
  result: any
}

export interface IRPCResultFailure {
  error: string
}

export interface IRPCResponseIdentifier {
  id: RPCID
}


/**
 * Binary outcome for RPCs, only success results or failure
 */
export interface IRPCResponse {
  id: RPCID
  result?: any
  error?: ISerializedError 
}

export interface IRPCResult {
  result?: any
  error?: ISerializedError 
}


export const errorTypes: { [key: string]: any} = {
  'TypeError': TypeError,
  'Error': Error,
}
